$(document).ready(function() {
    $('.collection-list-wrapper.collection-list-slider').show();
    $('.collection-list-wrapper.collection-list-slider .collection-list').slick({
    slidesToShow: 5,
    slidesToScroll: 5,
    infinite: true,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  // form a brands slider with slick
  $('.slick-section-container').show();
  $('.brands-responsive').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    swipeToSlide: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
});


const speed = 1;

$('.marquee').marquee({
    //duration in milliseconds of the marquee
    duration: window.innerWidth * 30000 / (1920 * speed),
  
    //gap in pixels between the tickers
    gap: 0,
  
    //time in milliseconds before the marquee will start animating
    delayBeforeStart: 0,
  
    //'left' or 'right'
    direction: 'left',
  
    //true or false - should the marquee be duplicated to show an effect of continues flow
    duplicated: true
});